import * as React from "react"
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/v2/lib/utils"
import { buttonVariants } from "./button"

function Calendar({
  className,
  showOutsideDays = true,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("relative px-3 pt-2 pb-3 w-[280px]", className)}
      classNames={{
        months: "flex flex-col gap-3",
        month: "flex flex-col gap-3",
        month_caption: "flex items-center justify-center h-9",
        caption_label: "text-sm font-medium",
        nav: "absolute top-3 inset-x-3 flex h-9 items-center justify-between pointer-events-none",
        button_previous: cn(
          buttonVariants({ variant: "ghost" }),
          "size-9 p-0 pointer-events-auto",
        ),
        button_next: cn(
          buttonVariants({ variant: "ghost" }),
          "size-9 p-0 pointer-events-auto",
        ),
        table: "w-full border-collapse",
        weekdays: "flex",
        weekday: "w-9 text-muted-foreground text-xs font-normal text-center",
        week: "mt-1 flex w-full",
        day: "relative w-9 h-9 p-0 text-center text-sm",
        day_button: cn(
          buttonVariants({ variant: "ghost" }),
          "size-9 p-0 font-normal aria-selected:opacity-100",
        ),
        selected: "bg-primary text-primary-foreground rounded-md hover:bg-primary hover:text-primary-foreground",
        today: "bg-highlight text-white rounded-md",
        outside: "text-muted-foreground opacity-50",
        disabled: "text-muted-foreground opacity-50",
        range_start: "bg-primary/15 rounded-l-full [&>button]:bg-primary [&>button]:text-primary-foreground [&>button]:rounded-full [&>button]:hover:bg-primary",
        range_end: "bg-primary/15 rounded-r-full [&>button]:bg-primary [&>button]:text-primary-foreground [&>button]:rounded-full [&>button]:hover:bg-primary",
        range_middle: "bg-primary/15 rounded-none [&>button]:bg-transparent [&>button]:text-foreground [&>button]:hover:bg-primary/25 [&>button]:rounded-md",
        hidden: "invisible",
      }}
      components={{
        Chevron: ({ orientation }) => {
          const Icon = orientation === "left" ? ChevronLeftIcon : ChevronRightIcon
          return <Icon className="size-4" />
        },
      }}
      {...props}
    />
  )
}

Calendar.displayName = "Calendar"

export { Calendar }
